"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function view() {
    var _this = this;
    return {
        state: {},
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onFilterApply: function () {
                _this.props.onFilterApply();
            },
            onFilterCancel: this.props.onFilterCancel,
            onResetFilters: this.props.onResetFilters,
            handleCollapsibleClick: this.props.handleCollapsibleClick,
            handleRadioButtonClick: this.props.onRadioButtonClick,
            handleCheckboxClick: this.props.onCheckboxClick,
            handleInputChange: this.props.onInputChange,
            handleDropdownSelect: this.props.onDropdownSelect,
            onShowMobileChecked: this.props.onShowMobileChecked
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobSearchFlyout/View.js
// module id = 752
// module chunks = 0